var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{staticStyle:{"overflow-y":"hidden"},attrs:{"id":"appy"}},[_c('div',{staticClass:"etabs-tabgroup"},[_c('div',{staticClass:"etabs-tabs"}),_c('div',{staticClass:"etabs-buttons"})]),_c('div',{staticClass:"etabs-views"},[_c('router-view')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }